import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);

export const unitPrice = (p, qty) =>
  qty >= 10 ? p.wholesale_tier_10 : qty >= 5 ? p.wholesale_tier_5 : p.retail_price;

export const tierLabel = (qty) =>
  qty >= 10 ? "Bulk Tier (10+)" : qty >= 5 ? "Volume Tier (5-9)" : "Standard";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("apx_cart") || "[]");
    } catch {
      return [];
    }
  });
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [checkoutOpen, setCheckoutOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("apx_cart", JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.product.id === product.id);
      if (ex)
        return prev.map((i) =>
          i.product.id === product.id ? { ...i, qty: i.qty + qty } : i
        );
      return [...prev, { product, qty }];
    });
    toast.success(`${product.name} added to order request`);
  };

  const setQty = (id, qty) =>
    setItems((prev) =>
      qty <= 0
        ? prev.filter((i) => i.product.id !== id)
        : prev.map((i) => (i.product.id === id ? { ...i, qty } : i))
    );

  const remove = (id) => setItems((prev) => prev.filter((i) => i.product.id !== id));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + unitPrice(i.product, i.qty) * i.qty, 0);

  return (
    <CartContext.Provider
      value={{
        items, add, setQty, remove, clear, count, subtotal,
        drawerOpen, setDrawerOpen, checkoutOpen, setCheckoutOpen,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
